import { render } from "./UpdateSMS.vue?vue&type=template&id=0c741ff8"
import script from "./UpdateSMS.vue?vue&type=script&lang=js"
export * from "./UpdateSMS.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__